"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Box_1 = require("../Box");
exports.CardContent = react_1.forwardRef((props, ref) => {
    return (jsx_runtime_1.jsx(Box_1.Box, Object.assign({ ref: ref, px: 4, py: 3, borderBottom: "1px solid rgba(120, 120, 120, 0.1)", _lastOfType: { borderBottom: 'none' } }, props), void 0));
});
//# sourceMappingURL=index.js.map